module.exports = __webpack_public_path__ + "img/service-details.ac3b1564.png";